import * as React from 'react'
import { useShowContext, SimpleShowLayout, Show, useTranslate, Loading, Error } from 'react-admin'
import {
  Grid,
  Container,
} from '@mui/material'
import { CardCommon } from 'src/components/uiElements'
import { ShowListElement } from 'src/components/uiElements/CRUD/ShowListElement'
import { CardCrudBottomButtons } from 'src/components/uiElements/CRUD/CardCrudBottomButtons'

const ShowWrapper = ({ children }) => <Container maxWidth='false'> {children}</Container>

const ShowContent = () => {
  const translate = useTranslate()
  const {
    error, // error returned by dataProvider when it failed to fetch the record. Useful if you want to adapt the view instead of just showing a notification using the `onError` side effect.
    isLoading, // boolean that is true until the record is available for the first time
    record, // record fetched via dataProvider.getOne() based on the id from the location
  } = useShowContext()

  if (isLoading) {
    return <Loading />
  }

  if (error) {
    return <Error />
  }

  return (
    <SimpleShowLayout>
      <CardCommon title={'Permisos'} actions={<CardCrudBottomButtons btnEdit={true} />}>
        <Grid container spacing={3}>
          <ShowListElement label={translate('ra.field.id')} value={record?.id} />
          <ShowListElement label={translate('ra.field.action')} value={record?.action} />
          <ShowListElement label={translate('ra.field.start_icon')} value={record?.start_icon} />

          <ShowListElement
            label={translate('ra.field.application')}
            value={record?.module?.application?.long_name}
          />
          <ShowListElement label={translate('ra.field.module')} value={record?.module?.long_name} />
          <ShowListElement label={translate('ra.field.description')} value={record?.description} />
          <ShowListElement label={translate('ra.field.entity')} value={record?.entity_relation?.name} />
          <ShowListElement label={translate('ra.field.menu')} value={record?.menu} type='boolean' />
        </Grid>
      </CardCommon>
    </SimpleShowLayout>
  )
}

export const PermissionShow = (props) => {
  return (
    <Show component={ShowWrapper} {...props} className='CrudShowContainer' actions={null}>
      <ShowContent {...props} />
    </Show>
  )
}
